import React, { useEffect, useState } from "react";
import {
  MdContactSupport,
  MdOutlineKeyboardArrowDown,
  MdOutlineKeyboardArrowLeft,
  MdPictureAsPdf,
} from "react-icons/md";
import { Link } from "react-router-dom";
import { Card, Row } from "react-bootstrap";
import axios from "axios";
import { toast } from "react-toastify";
import { RiArrowDownSLine } from "react-icons/ri";
import Billimg from "../components/Billimg";
import { useLocation } from "react-router-dom";
import { use } from "react";

const Informacion = () => {
  const location = useLocation();
  const [info, setInfo] = useState("");
  const [selectedValue2, setSelectedValue2] = useState("");
  const [guias, setGuias] = useState("");
  const [selectedValue, setSelectedValue] = useState("");
  const c2p = location?.state?.c2p;

  useEffect(() => {
    if (c2p) {
      setSelectedValue("0");
      setInfo("6");
    }
  }, [c2p]);

  const handleOptionClick = (e) => {
    setSelectedValue(e.target.value);
    const valueMap = {
      1: "0",
      2: "4",
      3: "5",
    };
    setInfo(valueMap[e.target.value] || "");
  };

  const handleInfo = (e) => {
    setInfo(e.target.value);
  };

  const fetchDataGuia = async () => {
    try {
      let response = await axios.get(
        `https://intranet.fibra360.net/api/config/intranet_config_residencial/guias_pago`
      );
      setGuias(response.data);
    } catch (error) {
      if (![200, 401].includes(error?.response?.status)) {
        toast.error("Ocurrio un error al cargar las guias.");
      }
    }
  };

  useEffect(() => {
    fetchDataGuia();
  }, []);

  const download = () => {
    const guiaSeleccionada = guias?.C2P?.find(
      (guia) => guia.name_guia === selectedValue2
    );
    if (guiaSeleccionada) {
      if (guiaSeleccionada.guia) {
        window.open(guiaSeleccionada.guia, "_blank");
      } else {
        console.error("La URL de la guía seleccionada está vacía.");
      }
    } else {
      console.error("No se encontró la guía seleccionada.");
    }
  };

  const downPagoMovil = () => {
    const guiaSeleccionada = guias?.pago_movil?.find(
      (guia) => guia.name_guia === selectedValue2
    );
    if (guiaSeleccionada) {
      if (guiaSeleccionada.guia) {
        window.open(guiaSeleccionada.guia, "_blank");
      } else {
        console.error("La URL de la guía seleccionada está vacía.");
      }
    } else {
      console.error("No se encontró la guía seleccionada.");
    }
  };

  const downIPG = () => {
    const guiaSeleccionada = guias?.IPG?.find(
      (guia) => guia.name_guia === selectedValue2
    );
    if (guiaSeleccionada) {
      if (guiaSeleccionada.guia) {
        window.open(guiaSeleccionada.guia, "_blank");
      } else {
        console.error("La URL de la guía seleccionada está vacía.");
      }
    } else {
      console.error("No se encontró la guía seleccionada.");
    }
  };

  const selectC2P = (e) => {
    setSelectedValue2(e.target.value);
  };

  return (
    <div>
      <div className="header-pago">
        <Link to="/pago" className="back">
          <div>
            <MdOutlineKeyboardArrowLeft className="btn-back" />
          </div>
          <div>
            <span>Volver</span>
          </div>
        </Link>
        <div className="d-flex  align-items-center">
          <MdContactSupport style={{ color: "#aaaaaa", fontSize: 35 }} />
          <h3
            className="text-center"
            style={{ fontWeight: "bold", color: "#aaaaaa" }}
          >
            Solicitar Ayuda
          </h3>
        </div>
      </div>
      <div className="containerPagos">
        <div className="pagosContainer">
          <Card
            className="p-0 m-0 card-help p-sm-5"
            style={{ boxShadow: "0 0 5px 1px #e9eaec", fontSize: 14 }}
          >
            <Card.Body className="center-all flex-column p-4">
              <select
                className="custom-input help-input mt-2 mb-4"
                style={{
                  backgroundColor: "#ffffff",
                  fontSize: 16,
                  color: "#4d4d4d",
                  width: "100%",
                }}
                value={selectedValue}
                onChange={handleOptionClick}
              >
                <option value="" disabled>
                  Método de pago que intenta utilizar
                </option>
                <option value="1">1.- Pago C2P</option>
                <option value="2">2.- Pago móvil</option>
                <option value="3">3.- Botón de pago BDV</option>
              </select>
              <select
                className="custom-input help-input mb-3"
                style={{
                  backgroundColor: "#ffffff",
                  fontSize: 16,
                  width: "100%",
                }}
                value={info}
                onChange={handleInfo}
              >
                <option value="" disabled>
                  Otros..
                </option>
                {selectedValue == "1" && (
                  <>
                    <option value="0">¿Comó funciona?</option>
                    <option value="6">¿Comó obtener mi token?</option>
                    <option value="1">Token invalido</option>
                  </>
                )}
                {selectedValue == "2" && (
                  <>
                    <option value="4">¿Comó funciona?</option>
                  </>
                )}
                {selectedValue == "3" && (
                  <>
                    <option value="5">¿Comó funciona?</option>
                    <option value="2">Token invalido</option>
                    <option value="3">Tiempo excedido</option>
                  </>
                )}
              </select>
              {info == "0" && (
                <>
                  <span
                    style={{
                      backgroundColor: "#d1d1d1",
                      borderRadius: 10,
                      width: "90%",
                    }}
                    className="text-center p-1 mb-3"
                  >
                    1.-Pago C2P
                  </span>
                  <h5 className="title-tutorial">
                    <strong>¿Cómo funciona?</strong>
                  </h5>
                  <Card
                    className="border-ayuda p-3 mt-3"
                    style={{ color: "#4d4d4d" }}
                  >
                    <p>
                      El sistem C2P utiliza un <strong>token único</strong> para
                      autorizar el debito de su Pago a la Información bancaria
                      suministrada en la plataforma.
                    </p>
                    <p className="mb-0">
                      Esto puede realizarse{" "}
                      <strong>desde una cuenta propia o de terceros</strong>.
                    </p>
                  </Card>
                </>
              )}
              {info == "4" && (
                <>
                  <span
                    style={{
                      backgroundColor: "#d1d1d1",
                      borderRadius: 10,
                      width: "90%",
                    }}
                    className="text-center p-1 mb-3"
                  >
                    2.-Pago Móvil
                  </span>
                  <h5 className="title-tutorial">
                    <strong>¿Cómo funciona?</strong>
                  </h5>
                  <Card
                    className="border-ayuda p-3 mt-4"
                    style={{ color: "#4d4d4d" }}
                  >
                    <p>
                      Con este método de pago, puede realizar el reporte y{" "}
                      <strong>verificación de su pago</strong> móvil{" "}
                      <strong>de manera inmediata.</strong>
                    </p>
                    <p>
                      <strong>
                        Funciona para los pagos realizados y reportados el mismo
                        día.
                      </strong>
                    </p>
                    <p className="mb-0">
                      En caso de que el reporte sea realizado en una{" "}
                      <strong>fecha diferente</strong> a la del pago{" "}
                      <strong>deberá esperar un plazo de 48 horas</strong> para
                      que su pago sea verificado.
                    </p>
                  </Card>
                  <div className="center-help mt-4">
                    <select
                      className="custom-input help-input p-4"
                      style={{
                        backgroundColor: "#ffffff",
                        fontSize: 16,
                        width: "100%",
                      }}
                      value={selectedValue2}
                      onChange={selectC2P}
                    >
                      <option value="" disabled>
                        Seleccione...
                      </option>
                      {guias?.pago_movil?.map((guia, index) => (
                        <option key={index} value={guia?.name_guia}>
                          {guia?.name_guia}
                        </option>
                      ))}
                    </select>
                  </div>
                </>
              )}
              {info == "5" && (
                <>
                  <span
                    style={{
                      backgroundColor: "#d1d1d1",
                      borderRadius: 10,
                      width: "100%",
                    }}
                    className="text-center p-1 mb-3"
                  >
                    1.-Botón de pago BDV
                  </span>
                  <h5 className="title-tutorial">
                    <strong>¿Cómo funciona?</strong>
                  </h5>
                  <Card
                    className="border-ayuda p-3 mt-4"
                    style={{ color: "#4d4d4d" }}
                  >
                    <p>
                      Este método de pago esta{" "}
                      <strong>
                        disponible para los clientes del Banco de Venezuela.
                      </strong>
                    </p>
                    <p>
                      Funciona mediante una <strong>plaforma externa </strong>la
                      cual debita el monto correspondiente en la cuenta BDV
                      especificada. Esto puede realizarse desde una cuenta
                      propia o de terceros.
                    </p>
                  </Card>
                  <div className="center-help mt-4">
                    <select
                      className="custom-input help-input p-4"
                      style={{
                        backgroundColor: "#ffffff",
                        fontSize: 16,
                        width: "100%",
                      }}
                      value={selectedValue2}
                      onChange={selectC2P}
                    >
                      <option value="" disabled>
                        Seleccione...
                      </option>
                      {guias?.IPG?.map((guia, index) => (
                        <option key={index} value={guia?.name_guia}>
                          {guia?.name_guia}
                        </option>
                      ))}
                    </select>
                  </div>
                </>
              )}
              {info == "1" && (
                <>
                  <h5 className="title-tutorial">
                    <strong>Token invalido</strong>
                  </h5>
                  <Card
                    className="border-ayuda p-3 mb-4"
                    style={{ color: "#4d4d4d" }}
                  >
                    <p>
                      Recuerde que debe ingresar el token recibido exactamente
                      igual a como se muestra en el sms.
                      <strong>
                        {" "}
                        Respetando las letras mayúsculas y minúsculas
                      </strong>
                    </p>
                    <p>
                      Se recomienda <strong>copiar y pegar el token</strong>{" "}
                      evitando los espacios en blanco al principio o final del
                      mismo para que sea verificado exitosamente.
                    </p>
                    <p className="mb-0">
                      Si continua el error espere unos minutos y{" "}
                      <strong>solicite un nuevo token</strong>.
                    </p>
                  </Card>
                </>
              )}
              {info == "3" && (
                <>
                  <h5 className="title-help title-tutorial" >
                    <strong>Tiempo excedido</strong>
                  </h5>
                  <Card
                    className="border-ayuda p-3"
                    style={{ color: "#4d4d4d" }}
                  >
                    <p>
                      {" "}
                      Este error suele ocurrir debido a fallas de conexión en la
                      plataforma BDV.
                    </p>
                    <p className="mb-0">
                      <strong>Siga intentando</strong> realizar la transacción
                      <strong> hasta que el pago sea procesado</strong> y
                      debitado correctamente en la cuenta bancaria
                      correspondiente
                    </p>
                  </Card>
                </>
              )}
              {info == "2" && (
                <>
                  <h5 className="title-tutorial">
                    <strong>Token invalido</strong>
                  </h5>
                  <Card
                    className="border-ayuda p-3"
                    style={{ color: "#4d4d4d" }}
                  >
                    <p>
                      Recuerde que debe ingresar el token recibido exactamente
                      igual a como se muestra en el sms.{" "}
                      <strong>
                        {" "}
                        Respetando las letras mayúsculas y minúsculas.
                      </strong>
                    </p>
                    <p>
                      Se recomienda <strong>copiar y pegar el token</strong>{" "}
                      evitando los espacios en blanco al principio o final del
                      mismo para que sea verificado exitosamente.
                    </p>
                    <p className="mb-0">
                      Si continua el error espere unos minutos y{" "}
                      <strong>solicite un nuevo token.</strong>
                    </p>
                  </Card>
                </>
              )}
            </Card.Body>
          </Card>
          {info == "6" && (
            <Card
              className="p-0 mt-3 card-help"
              style={{
                color: "#4d4d4d",
                boxShadow: "0 0 5px 1px #e9eaec",
                fontSize: 14,
                width: "100%",
              }}
            >
              <Card.Body className="center-all flex-column pt-5 ps-5 pe-5 pb-1">
                <h5 className="title-tutorial">
                  <strong>¿Cómo obtener mi token?</strong>
                </h5>
                <p className="mt-3">
                  El método de generación para su token suele{" "}
                  <strong>variar según el banco </strong>
                  que utilice.
                </p>
                <p>
                  Le ofremos algunas <strong>guías</strong> para los bancos más
                  utilizados puede descargarlas indicando el suyo y pulsando el
                  botón de descargar.
                </p>
                <select
                  className="custom-input help-input  mb-4"
                  style={{
                    backgroundColor: "#ffffff",
                    fontSize: 16,
                    width: "100%",
                  }}
                  value={selectedValue2}
                  onChange={selectC2P}
                >
                  <option value="" disabled>
                    Seleccione...
                  </option>
                  {guias?.C2P?.map((guia, index) => (
                    <option key={index} value={guia?.name_guia}>
                      {guia?.name_guia}
                    </option>
                  ))}
                </select>
              </Card.Body>
            </Card>
          )}
          {info == "4" && (
            <>
              <div className="center-help">
                <button
                  className="p-3 eliminarB mt-3 button-send"
                  onClick={downPagoMovil}
                  style={{
                    backgroundColor: "#ffffff",
                    color: selectedValue2 ? "#2196F3" : "#aaaaaa",
                    fontWeight: "bold",
                    fontSize: 18,
                    borderRadius: 5,
                    display: "flex",
                    justifyContent: "space-around",
                    alignItems: "center",
                  }}
                >
                  <MdPictureAsPdf className="me-2" style={{ fontSize: 30 }} />
                  <span style={{ marginRight: 80 }}>Descargar Guía</span>
                  <MdOutlineKeyboardArrowDown style={{ fontSize: 45 }} />
                </button>
              </div>
            </>
          )}
          {info == "5" && (
            <div className="center-help">
              <button
                className="p-3 eliminarB mt-3 button-send "
                onClick={downIPG}
                style={{
                  backgroundColor: "#ffffff",
                  color: selectedValue2 ? "#2196F3" : "#aaaaaa",
                  fontWeight: "bold",
                  fontSize: 18,
                  borderRadius: 5,
                  display: "flex",
                  justifyContent: "space-around",
                  alignItems: "center",
                }}
              >
                <MdPictureAsPdf style={{ fontSize: 30 }} />
                <span style={{ marginRight: 80 }}>Descargar Guía</span>
                <MdOutlineKeyboardArrowDown style={{ fontSize: 45 }} />
              </button>
            </div>
          )}
          {info == "6" && (
            <div className="center-help">
              <button
                className="p-3 eliminarB mt-3 button-send"
                onClick={download}
                style={{
                  backgroundColor: "#ffffff",
                  color: selectedValue2 ? "#2196F3" : "#aaaaaa",
                  fontWeight: "bold",
                  fontSize: 18,
                  borderRadius: 5,
                  display: "flex",
                  justifyContent: "space-around",
                  alignItems: "center",
                }}
              >
                <MdPictureAsPdf className="me-2" style={{ fontSize: 30 }} />
                <span className="ms-sm-2 me-sm-5">Descargar guía</span>{" "}
                <RiArrowDownSLine className="ms-5" style={{ fontSize: 35 }} />
              </button>
            </div>
          )}
        </div>
        <div className="side-image">
          <Billimg />
        </div>
      </div>
    </div>
  );
};

export default Informacion;
